/*
Copyright (C) 2026  Tech9IQ
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

/**
 * The Tech9IQ preloader in public/index.html (the same in every Tech9IQ app):
 * the logo and a progress bar, up from the first paint while Swift checks the
 * session or signs the person in from Tech9IQ, so no sign-in page or empty
 * shell flashes on the way. It shows while <html> has the t9-preload class.
 */
export const hidePreloader = (): void => {
  document.documentElement.classList.remove("t9-preload");
};
